import { type SVGProps } from "react";

import { cn } from "@/shared/helpers/cn.helper";

interface ArrowTrIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export const ArrowTrIcon = ({ className, ...props }: ArrowTrIconProps) => (
  <svg
    className={cn("text-light-400", className)}
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.00005 19L19 5.99996M19 5.99996V18.48M19 5.99996H6.52005"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
  </svg>
);

export default ArrowTrIcon;
